export default "__VITE_PUBLIC_ASSET__512c390f__"